import { normalizeHTML } from 'anodum';

const parseFragmentFromString = (html) => {
  const normalizedHTML = normalizeHTML(html);
  const tpl = document.createElement('template');
  tpl.innerHTML = normalizedHTML;
  const fragment = tpl.content;

  return fragment;
};

export default parseFragmentFromString;
